export const SIZES = {
    tiny: 'tiny',
    small: 'small',
    medium: 'medium',
};
export const DIRECTIONS = {
    horizontal: 'horizontal',
    vertical: 'vertical',
};
//# sourceMappingURL=constants.js.map